import { type EhrCredentialV2 } from '../../models/orchestrator/credential.js';
import {
  type CredentialCheckout,
  type FindAllOptions,
} from '../../models/orchestrator/credentialCheckout.js';
import OrchestratorAPI from '../common.js';

export default class API extends OrchestratorAPI {
  protected readonly API_PATH = '/ehr-credentials/checkouts';
  public readonly baseEndpoint = `${this.BASE_URL}${this.API_PATH}`;

  async findAll(options?: FindAllOptions): Promise<CredentialCheckout[]> {
    const url = this.constructPath('/', options);
    const { checkouts } = await this.common.getJSON(url);
    return checkouts.map(this.deserialize);
  }

  async checkIn(checkoutId: string): Promise<CredentialCheckout> {
    const url = this.constructPath(`/${checkoutId}/checkin`);
    const { checkout } = await this.common.patchJSON(url);
    return this.deserialize(checkout);
  }

  async checkOut(ehrInstanceId: string): Promise<EhrCredentialV2 | null> {
    const url = this.constructPath('/');
    const { credential } = await this.common.postJSON(url, { ehrInstanceId });
    return credential;
  }
}
